import { DtOperate } from '@ow/ditto-core'

const { transformer } = DtOperate
export { transformer }
